// extracted by mini-css-extract-plugin
export default {"editRow":"R4B9S","check":"a44Q5","price":"iEn1I","input":"XJiPN","status":"Zi7ms","buttons":"dq60F","currencyOption":"MHJCV"};